module.exports = __webpack_public_path__ + "static/media/DaciaSpirit-Bold_V1000.0007f99e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/spirit/DaciaSpirit-Bold_V1000.woff
// module id = 656
// module chunks = 0